import ConfigurationLeftPanel from "./configurationLeftPanel";
export default ConfigurationLeftPanel;
